// extracted by mini-css-extract-plugin
module.exports = {"table_head":"Table_table_head__2bZp0","table_body":"Table_table_body__3sl4M"};